import { render, staticRenderFns } from "./WarningPopup.vue?vue&type=template&id=5f40cb08&"
import script from "./WarningPopup.vue?vue&type=script&lang=js&"
export * from "./WarningPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f40cb08')) {
      api.createRecord('5f40cb08', component.options)
    } else {
      api.reload('5f40cb08', component.options)
    }
    module.hot.accept("./WarningPopup.vue?vue&type=template&id=5f40cb08&", function () {
      api.rerender('5f40cb08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/vendor/WarningPopup.vue"
export default component.exports